import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '@/store'

const selectViewState = (state: RootState) => state.dashboardWidgets

export const selectDashboardWidgets = createSelector(selectViewState, (state) => state.widgets)
